var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61555 0.676337C6.99076 -0.0348095 8.00924 -0.0348077 8.38445 0.676339L9.86856 3.48926C10.0133 3.7635 10.277 3.95511 10.5825 4.00798L13.7164 4.55021C14.5087 4.6873 14.8234 5.65593 14.263 6.23253L12.0464 8.51325C11.8303 8.73561 11.7295 9.04564 11.7737 9.35255L12.2264 12.5006C12.3408 13.2965 11.5169 13.8951 10.7953 13.5403L7.94125 12.137C7.66299 12.0001 7.33701 12.0001 7.05875 12.137L4.20468 13.5403C3.48313 13.8951 2.65917 13.2965 2.77362 12.5006L3.22634 9.35255C3.27048 9.04564 3.16974 8.73561 2.95363 8.51325L0.737002 6.23253C0.176606 5.65593 0.491337 4.6873 1.28362 4.55021L4.41748 4.00798C4.72302 3.95511 4.98674 3.7635 5.13144 3.48926L6.61555 0.676337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.db9a75a0b2c1ca6c8ca4a3afba695ca7.svg";
export { ForwardRef as ReactComponent };